export const MAIL_CHIMP_API = "/mailChimp";